import React from "react";
import { FaChartLine, FaUsers } from "react-icons/fa";

function SubscriptionReportCard({ subscriptionReportsData }) {
  return (
    <div className="space-y-4">
      {Object.entries(subscriptionReportsData.mrrBySubscriptionPlan || {}).map(
        ([planName, plan]) => (
          <div
            key={planName}
            className="flex items-center justify-between p-4 bg-[#F8F9FC] rounded-lg"
          >
            <div className="flex items-center gap-4 flex-1">
              <div className="w-10 h-10 rounded-lg bg-white border border-gray-200 flex items-center justify-center">
                <FaUsers className="w-5 h-5 text-[#1E61DC]" />
              </div>

              <div>
                <div className="flex items-center gap-2">
                  <span className="text-[#1A1A1A] capitalize">{planName}</span>
                  <span className="text-[#1E61DC]">
                    ${plan.pricePerMonth.toLocaleString()}/mo
                  </span>
                </div>

                <div className="text-[#6B7280]">
                  {plan.subscriberCount.toLocaleString()} subscribers •{" "}
                  {plan.features.join(", ")}
                </div>
              </div>
            </div>

            <div className="text-right">
              <div className="text-[#1A1A1A]">
                ${plan.monthlyRevenue.toLocaleString()}/mo
              </div>

              <div className="flex items-center gap-1 text-green-600">
                <FaChartLine className="w-4 h-4" />
                <span>+{plan.growthPercentage ?? 0}%</span>
              </div>
            </div>
          </div>
        ),
      )}
    </div>
  );
}

export default SubscriptionReportCard;
